import { combineReducers } from 'redux'
import actionTypes from './actionTypes'

export const viewer = (state = { viewer: null }, action: any) => {
  switch (action.type) {
    case actionTypes.SET_VIEWER:
      return action.viewer
    default:
      return state
  }
}

export const layers = (state: { [propName: string]: any } = {}, action: any) => {
  switch (action.type) {
    case actionTypes.SET_LAYERS:
      return {...state, ...action.data}
    default:
      return state
  }
}

export const treeData = (state: any[] = [], action: any) => {
  switch (action.type) {
    case actionTypes.SET_TREE_DATA:
      return [...action.data]
    default:
      return state
  }
}

export const checkedKeys = (state: any[] = [], action: any) => {
  switch (action.type) {
    case actionTypes.SET_CHECKED_KEYS:
      return [...action.data]
    default:
      return state
  }
}

export const entities = (state: { [propName: string]: any } = {}, action: any) => {
  switch (action.type) {
    case actionTypes.SET_ENTITIES:
      let temp = { ...state }
      if (temp[action.data.key]) {
        temp[action.data.key] = [...state[action.data.key], action.data.id]
      } else {
        temp[action.data.key] = [action.data.id]
      }
      return temp
    default:
      return state
  }
}

export const markerEntities = (state: { [propName: string]: any } = {}, action: any) => {
  switch (action.type) {
    case actionTypes.SET_MARKER_ENTITIES:
      return {...state, ...action.data}
    default:
      return state
  }
}

export const logoutModal = (state = { show: false }, action: any) => {
  switch (action.type) {
    case actionTypes.SET_LOGOUT_MODAL:
      return action.data
    default:
      return state
  }
}

export const originModal = (state = { show: false }, action: any) => {
  switch (action.type) {
    case actionTypes.SET_ORIGIN_MODAL:
      return action.data
    default:
      return state
  }
}

export const positionModal = (state = { show: false }, action: any) => {
  switch (action.type) {
    case actionTypes.SET_POSITION_MODAL:
      return action.data
    default:
      return state
  }
}

export const measureVolumeModal = (state = { show: false }, action: any) => {
  switch (action.type) {
    case actionTypes.SET_MEASURE_VOLUME_MODAL:
      return action.data
    default:
      return state
  }
}

export const gridInfo = (state = {}, action: any) => {
  switch (action.type) {
    case actionTypes.START_SET_GRID_INFO:
      return {
        ...state,
        isLoading: true
      }
    case actionTypes.END_SET_GRID_INFO:
      return {
        ...state,
        isLoading: false
      }
    case actionTypes.SET_GRID_INFO:
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export const gridUserModal = (state = { show: false }, action: any) => {
  switch (action.type) {
    case actionTypes.SET_GRID_USER_MODAL:
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export const calendarModal = (state = { show: false }, action: any) => {
  switch (action.type) {
    case actionTypes.SET_CALENDAR_MODAL:
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export const userWarningModal = (state = { show: false }, action: any) => {
  switch (action.type) {
    case actionTypes.SET_USER_WARNING_MODAL:
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export const gridWarningModal = (state = { show: false }, action: any) => {
  switch (action.type) {
    case actionTypes.SET_GRID_WARNING_MODAL:
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export const markerLabelInfo = (state = { type: null, id: null, data: {} }, action: any) => {
  switch (action.type) {
    case actionTypes.SHOW_LABEL_MODAL:
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export const markerList = (state = { list: [], total: 0 }, action: any) => {
  switch (action.type) {
    case actionTypes.SET_MARKER_LIST:
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export const markerListLoading = (state = false, action: any) => {
  switch (action.type) {
    case actionTypes.SET_MARKER_LIST_LOADING:
      return action.data
    default:
      return state
  }
}

export const markerListPage = (state = 1, action: any) => {
  switch (action.type) {
    case actionTypes.SET_MARKER_LIST_PAGE:
      return action.data
    default:
      return state
  }
}

export const markerListPageSize = (state = 10, action: any) => {
  switch (action.type) {
    case actionTypes.SET_MARKER_LIST_PAGE_SIZE:
      return action.data
    default:
      return state
  }
}

export const markerListKeyword = (state = '', action: any) => {
  switch (action.type) {
    case actionTypes.SET_MARKER_LIST_KEYWORD:
      return action.data
    default:
      return state
  }
}

export const markerListStartAddTime = (state = '', action: any) => {
  switch (action.type) {
    case actionTypes.SET_MARKER_LIST_START_TIME:
      return action.data
    default:
      return state
  }
}

export const markerListEndAddTime = (state = '', action: any) => {
  switch (action.type) {
    case actionTypes.SET_MARKER_LIST_END_TIME:
      return action.data
    default:
      return state
  }
}

export const markerReport = (state = {}, action: any) => {
  switch (action.type) {
    case actionTypes.SET_MARKER_REPORT:
      return action.data
    default:
      return state
  }
}


export const markerCurrent = (state: any = null, action: any) => {
  switch (action.type) {
    case actionTypes.SET_MARKER_CURRENT:
      return action.data
    default:
      return state
  }
}


export const markerCheckeds = (state = [], action: any) => {
  switch (action.type) {
    case actionTypes.SET_MARKER_CHECKEDS: 
      return action.data
    default:
      return state
  }
}

export const uavTrack = (state = {}, action: any) => {
  switch (action.type) {
    case actionTypes.SET_UAV_TRACK:
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export const videoList = (state: any[] = [], action: any) => {
  switch (action.type) {
    case actionTypes.SET_VIDEO_LIST:
      // return [...action.data]
      return action.data
    default:
      return state
  }
}

export const standingBook = (state = {}, action: any) => {
  switch (action.type) {
    case actionTypes.SHOW_STANDING_BOOK:
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export const standingBookAdd = (state = {}, action: any) => {
  switch (action.type) {
    case actionTypes.SHOW_STANDING_BOOK_ADD:
      return action.data
    default:
      return state
  }
}

export default combineReducers({
  viewer,
  layers,
  treeData,
  checkedKeys,
  entities,
  markerEntities,
  logoutModal,
  originModal,
  positionModal,
  measureVolumeModal,
  gridInfo, 
  gridUserModal,
  calendarModal,
  userWarningModal,
  gridWarningModal,
  markerLabelInfo,
  markerList,
  markerListLoading,
  markerListPage,
  markerListPageSize,
  markerListKeyword,
  markerListStartAddTime,
  markerListEndAddTime,
  markerReport, 
  markerCurrent,
  markerCheckeds,
  uavTrack,
  videoList,
  standingBook,
  standingBookAdd
})